import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";

const LanguageSkills = ({ newdata, setNewdata }) => {
  // Get languages from main CVForm state
  const languageskils = newdata.languageskils || [];

  // Handle input changes
  const handelvalues = (e, index) => {
    const { name, value } = e.target;
    const updated = [...languageskils];
    updated[index] = { ...updated[index], [name]: value };
    setNewdata(prev => ({ ...prev, languageskils: updated }));
  };

  // Add new language row
  const AddmoreFields = () => {
    setNewdata(prev => ({
      ...prev,
      languageskils: [
        ...languageskils,
        { language: "", speakingproficiency: "", writingproficiency: "", readingproficiency: "" }
      ]
    }));
  };

  // Remove language row
  const handleRemoveClick = index => {
    setNewdata(prev => ({
      ...prev,
      languageskils: languageskils.filter((_, i) => i !== index)
    }));
  };

  return (
    <div className="px-2">
      {languageskils.map((lang, index) => (
        <div key={index}>
          <Row className="mb-2">
            <Col md={4}>
              <Form.Label className="custm-lble">Language</Form.Label>
              <Form.Control
                placeholder="Language"
                type="text"
                name="language"
                value={lang.language}
                onChange={e => handelvalues(e, index)}
              />
            </Col>
            <Col md={4}>
              <Form.Label className="custm-lble">Speaking Proficiency</Form.Label>
              <Form.Control
                placeholder="Speaking Proficiency"
                type="text"
                name="speakingproficiency"
                value={lang.speakingproficiency}
                onChange={e => handelvalues(e, index)}
              />
            </Col>
            <Col md={4}>
              <Form.Label className="custm-lble">Reading Proficiency</Form.Label>
              <Form.Control
                placeholder="Reading Proficiency"
                type="text"
                name="readingproficiency"
                value={lang.readingproficiency}
                onChange={e => handelvalues(e, index)}
              />
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md={4}>
              <Form.Label className="custm-lble">Writing Proficiency</Form.Label>
              <Form.Control
                placeholder="Writing Proficiency"
                type="text"
                name="writingproficiency"
                value={lang.writingproficiency}
                onChange={e => handelvalues(e, index)}
              />
            </Col>
          </Row>

          {index !== 0 && (
            <div
              className="d-flex justify-content-end cursor_P mb-2"
              onClick={() => handleRemoveClick(index)}
            >
              <DeleteIcon className="color-red" />
              <p className="color-remove-red mb-0 ms-1">Remove</p>
            </div>
          )}

          <hr className="mb-3" />
        </div>
      ))}

      <div className="mb-3" onClick={AddmoreFields}>
        <p className="color-text cursor_P">
          <AddCircleIcon style={{ fontSize: "large" }} /> Add More
        </p>
      </div>
    </div>
  );
};

export default LanguageSkills;
